import React, { useEffect, useState } from "react";
import { StandartButton } from "commons/form-controls";
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg';
import s from "./save-button.module.scss";

const SaveButton = (props) => {

    const [type, setType] = useState(props.type);
    const [title, setTitle] = useState(props.title);
    const [isDisabled, setIsDisabled] = useState(props.disabled);

    useEffect(() => {
        setType(props.type);
        setTitle(props.title);
        setIsDisabled(props.disabled);
    }, [props.title, props.type, props.disabled]);

    const clickHandler = () => {
        props.callback(type);
    }

    return (
        <div className={s.SaveButton}>
            <StandartButton disabled={isDisabled} icon={SaveIcon} fill={'white'} callback={clickHandler} title={title}/>
        </div>
    )
}

export default SaveButton;